
import { getUser, getCollege } from '../common/js/cache'

const state = {
	user: getUser(),
	// user: {
	// 	id: 2,
	// 	showname: '你的名字',
	// 	nickname:'ni陈'
	// },
	college: getCollege(),
}

export default state


// WEBPACK FOOTER //
// ./src/store/state.js